<template>
  <v-container fluid class="fill-height">
    <v-row justify="center" align="center">
      <v-col v-if="[25, 157].includes(clientId)" cols="12" md="8">
        <v-card flat>
          <v-card-title class="headline">Formulario externo</v-card-title>
          <v-card-text>
            <div ref="bitrixForm"></div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col else cols="12" md="8">
        <v-card class="mt-10" flat>
          <v-card-text class="text-center">
            No hay formulario externo disponible
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  computed: {
    clientId() {
      return this.$store.getters["passport/GET_CLIENT_ID"];
    },
  },

  mounted() {
    this.loadBitrixForm();
  },

  methods: {
    loadBitrixForm() {
      const script = document.createElement("script");
      script.async = true;
      script.dataset.b24Form = "inline/124/hohc03";
      script.dataset.skipMoving = "true";
      script.src =
        "https://cdn.bitrix24.es/b15852515/crm/form/loader_124.js?" +
        (Date.now() / 180000 | 0);

      this.$refs.bitrixForm.appendChild(script);
    },
  },
};
</script>
